import { Box } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const CostDistributionChipWrapper = styled(Box)`
  display: flex;
  height: 24px;
  padding: 2px 8px;
  justify-content: center;
  align-items: center;
  gap: 3px;
  border-radius: 8px;
  background: ${theme.colors.legacyPrimaryLight3};
  width: fit-content;

  .MuiTypography-root {
    color: ${theme.colors.cta};
    text-align: center;
    font-family: Quicksand, sans-serif;
    font-size: 12px;
    font-style: normal;
    font-weight: 500;
    line-height: 16px;
    letter-spacing: 0.5px;
  }
`
